import { pdfjs } from 'react-pdf';

// Use the worker from the public folder
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;
